module.exports = __webpack_public_path__ + "img/ky.ec6d0c3f.svg";